import { createTheme, type ThemeOptions } from '@mui/material/styles'
import { typography } from './typography'
import { componentOverrides } from './components'

/**
 * Base theme configuration shared by both light and dark themes.
 * Contains typography, spacing, shape, breakpoints, and component overrides.
 */
export const baseThemeOptions: ThemeOptions = {
    typography,
    spacing: 8, // Default MUI spacing unit
    shape: {
        borderRadius: 4, // Default MUI border radius
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    components: componentOverrides,
}

/**
 * Creates a base theme with shared configuration.
 * This is extended by lightTheme and darkTheme with palette overrides.
 */
export const baseTheme = createTheme(baseThemeOptions)
